import axios from 'axios';

export default {
  getConfig(path) {
    return axios.get(`${process.env.VUE_APP_PUBLIC_URL}/config/${path}.json?nocache=${(new Date()).getTime()}`);
  }
};
